import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=b4e18636&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e18636",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4e18636')) {
      api.createRecord('b4e18636', component.options)
    } else {
      api.reload('b4e18636', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=b4e18636&scoped=true&", function () {
      api.rerender('b4e18636', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2BJhLeiOazKgm/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports